import axios from "./axios.interceptors";
import { Reservations } from "../types/service-types/ReservationsTypes";

class ReservationsServices {
  public getReservations = async (isPast?: boolean): Promise<Reservations[]> => {
    const accessToken = localStorage.getItem("pr_jet_access_token");

    const response = await axios.get("/api/v1/reservations", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: isPast === undefined ? undefined : { isPast },
    });

    return response.data;
  };
}

export default new ReservationsServices();
